import FEATURE_LABELS from "./featureLabels"

export default function PricingComparisonTable({ plans, billingType = "monthly", currentUserPlan }) {
  const planKeys = plans.map((p) => p.key)

  const BRAND = {
    primary: "#3B82F6",
    primaryDark: "#2563EB",
    primarySoft: "rgba(59, 130, 246, 0.05)",
    success: "#22C55E",
    warning: "#F59E0B",
    text: "#1F2937",
    muted: "#4B5563",
    border: "#DBEAFE",
    addOnGradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
  }

  const displayValue = (val) => {
    if (typeof val === "boolean") {
      return val ? (
        <span style={{ color: BRAND.success, fontSize: "1.25rem", fontWeight: "bold" }}>✔</span>
      ) : (
        <span style={{ color: "#9CA3AF", fontSize: "1.25rem" }}>✖</span>
      )
    }
    if (val === "add-on") {
      return (
        <span
          style={{
            background: BRAND.addOnGradient,
            color: "white",
            padding: "0.25rem 0.5rem",
            borderRadius: "6px",
            fontSize: "0.75rem",
            fontWeight: "600",
          }}
        >
          Add-on
        </span>
      )
    }
    if (Array.isArray(val)) return val.join(", ")
    return val ?? "-"
  }

  const featureSections = Object.keys(plans[0]?.features || {})
  const allRows = featureSections.flatMap((section) =>
    Object.entries(plans[0].features[section] || {}).map(([key]) => ({
      section,
      feature: key,
    })),
  )

  return (
    <div
      className="table-responsive"
      style={{
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
      }}
    >
      <table className="table align-middle mb-0" style={{ background: "white" }}>
        <thead>
          <tr style={{ background: "#F3F4F6" }}>
            <th
              style={{
                padding: "1.25rem 1.5rem",
                fontWeight: "700",
                fontSize: "1rem",
                color: BRAND.text,
                borderBottom: `2px solid ${BRAND.border}`,
              }}
            >
              Feature
            </th>
            {plans.map((p) => {
              const isCurrent = p.key === currentUserPlan
              return (
                <th
                  key={p.key}
                  className="text-center"
                  style={{
                    padding: "1.25rem 1.5rem",
                    fontWeight: "700",
                    fontSize: "0.95rem",
                    color: isCurrent ? "#FFFFFF" : BRAND.text,
                    background: isCurrent
                      ? `linear-gradient(135deg, ${BRAND.primary} 0%, ${BRAND.primaryDark} 100%)`
                      : "transparent",
                    borderBottom: `2px solid ${BRAND.border}`,
                  }}
                >
                  <div>{p.title}</div>
                  <div
                    style={{
                      fontSize: "0.875rem",
                      fontWeight: "600",
                      marginTop: "0.25rem",
                      color: isCurrent ? "#DBEAFE" : "#6B7280",
                    }}
                  >
                    {billingType === "monthly"
                      ? `$${p.price.monthly}/mo`
                      : `$${p.price.yearly}/yr`}
                  </div>
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {allRows.map(({ section, feature }, index) => (
            <tr
              key={`${section}-${feature}`}
              style={{
                background: index % 2 === 0 ? "#ffffff" : "#F9FAFB",
                transition: "background-color 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#EFF6FF"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = index % 2 === 0 ? "#ffffff" : "#F9FAFB"
              }}
            >
              <td
                style={{
                  padding: "1rem 1.5rem",
                  fontWeight: "600",
                  color: BRAND.text,
                  fontSize: "0.95rem",
                  borderBottom: `1px solid ${BRAND.border}`,
                }}
              >
                {FEATURE_LABELS[feature] || feature}
              </td>
              {planKeys.map((planKey) => {
                const val = plans.find((p) => p.key === planKey)?.features[section]?.[feature]
                const isCurrentPlan = planKey === currentUserPlan
                return (
                  <td
                    key={planKey}
                    className="text-center"
                    style={{
                      padding: "1rem 1.5rem",
                      background: isCurrentPlan ? BRAND.primarySoft : "transparent",
                      borderBottom: `1px solid ${BRAND.border}`,
                      fontWeight: "500",
                      fontSize: "0.9rem",
                      color: BRAND.muted,
                    }}
                  >
                    {displayValue(val)}
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
